import React, { useRef } from "react";
import Form from 'react-bootstrap/Form';

function NextAirport(props) {
    const index = props.index;
    const messageValues = props.messageValues;
    const setMessageValues = props.setMessageValues;
    const updateParent = props.updateParent;
    const setCurrentFocus = props.setCurrentFocus
    const currentFocus = props.currentFocus
    const inputRef = useRef(null);

    if (inputRef.current && currentFocus == 'NextAirport_' + index) {
        inputRef.current.focus();
    }

    function airportEntered(value) {
        if (value != '') {
            setCurrentFocus('nextAirportIataCode_' + index)
            messageValues['flightDetailLines'][index]['nextAirportIataCode'] = value
            setMessageValues(messageValues)
            updateParent()
        }
    }

    let hasFocus = currentFocus === 'nextAirportIataCode_' + index ? true : false

    return (
        <>
            <p className="text-muted mb-0 small">Next</p>
            <Form.Control
                key={Math.random()}
                aria-label="Origin"
                type="text"
                defaultValue={messageValues['flightDetailLines'][index]['nextAirportIataCode']}
                onChange={e => { airportEntered(e.target.value) }}
                onClick={() => { setCurrentFocus('NextAirport_' + index) }}
                autoFocus={hasFocus}
                ref={inputRef}
            />
        </>
    );
}

export default NextAirport